export enum RoutePath {
  Home = '/web',
  Analysis = '/web/analysis',
  Analysis_place = '/web/analysis/place',
  Vehicle = '/web/vehicle',
  Vehicle_detail = '/web/vehicle/detail',
  Vehicle_setting = '/web/vehicle/setting',
  Vehicle_unpaid_toll = '/web/unpaid_toll',
  Vehicle_unpaid_toll_bridge = '/web/unpaid_toll/bridge',
  Vehicle_unpaid_toll_result = '/web/unpaid_toll/result',
  Insurance_tab = '/web/insurance-tab',
  Benefit_home = '/web/benefit',
  Benefit_list = '/web/benefit/list',
  Benefit_detail = '/web/benefit/detail',
  Benefit_popular = '/web/benefit/popular', // 레거시 리디렉션용
  Benefit_point = '/web/benefit/point',
  History = '/web/history',
  History_detail = '/web/history/detail',
  Insurance_driver = '/web/insurance/driver',
  Insurance_driver_result = '/web/insurance/driver/result',
  Insurance_driver_history = '/web/insurance/driver/history',
  Insurance_driver_history_detail = '/web/insurance/driver/history/detail',
  License_penalty = '/web/penalty',
  License_penalty_input = '/web/penalty/input',
  License_penalty_result = '/web/penalty/result',
  Settings = '/web/settings',
  Settings_otp = '/web/settings/otp',
  Settings_withdrawal = '/web/settings/withdrawal',
  Etc_insurer_contact = '/web/etc/contact',
  Etc_emergency_call = '/web/etc/emergency',
  Etc_terms = '/web/etc/terms',
}
